<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div class="btn btn-hover bg-secondary-color">Become POS Agent</div>
      <div class="big-caption text-default-color">
          Want to be an agent and have access to our HuiosPay POS<br> 
      </div>
      <p style="text-align: center;">We look forward to working with you to meet your growth goals!</p>
    </div>
  </div>


  <div class="container d-flexbox">
      <form
      [formGroup]="agentForm"
      (ngSubmit)="registerAgent()"
      class="form d-flexbox col justify-content-left align-items-top">
          <div class="d-flexbox row justify-content-between flex-wrap">
              <div class="d-flexbox col justify-content-left align-items-top input-grouping">
                  <label for="firstName" class="caption-primary-color">First name</label>
                  <input type="text" formControlName="firstName" placeholder="Ex. Jane">
              </div>
              <div class="d-flexbox col justify-content-left align-items-top input-grouping">
                  <label for="lastName" class="caption-primary-color">Last name</label>
                  <input type="text" formControlName="lastName" placeholder="Ex. Tailor">
              </div>
          </div>

          <div class="d-flexbox row justify-content-between flex-wrap">
              <div class="d-flexbox col justify-content-left align-items-top input-grouping">
                  <label for="email" class="caption-primary-color">Email</label>
                  <input type="email" formControlName="email" placeholder="example@mail.com">
              </div>
              <div class="d-flexbox col justify-content-left align-items-top input-grouping">
                  <label for="phoneNumber" class="caption-primary-color">Phone number</label>
                  <input type="tel" formControlName="phoneNumber" placeholder="0801 001 0001">
              </div>
          </div>

          <div class="d-flexbox row justify-content-between flex-wrap">
            <div class="d-flexbox col justify-content-left align-items-top input-grouping">
                <label for="email" class="caption-primary-color">Business Address</label>
                <input type="text" formControlName="address" placeholder="Ex. Marcus & Sons">
            </div>
            <div class="d-flexbox col justify-content-left align-items-top input-grouping">
                <label for="phoneNumber" class="caption-primary-color">Residential Address</label>
                <input type="text" formControlName="residentialAddress" placeholder="Ex. Abuja">
            </div>
        </div>

          <label for="businessName" class="caption-primary-color">Business name</label>
          <input type="text" formControlName="businessName" placeholder="Ex. Marcus & Sons">


          <!-- <label for="noPosReq" class="caption-primary-color">No of POS required</label>
          <input type="number" formControlName="noPosReq" placeholder="1" min="1"> -->

          <div class="btn fill" (click)="registerAgent()">Apply</div>

      </form>
  </div>

 <!-- Community section-->
 <app-community-section></app-community-section>
 <!--End Community section-->

 <!-- footer -->
 <app-footer></app-footer>
 <!-- end of footer -->


<app-back-to-top
[acceleration]="2"
[animate]="true"
[scrollDistance]="50"
[speed]="50"
>
</app-back-to-top>
